 
$(".slick-arrow").click(function() {
  var attr = $(".slick-track .slick-current a").attr("data-image");
  console.log(attr);
});

// DROPDOWN See the format in cart page LSF
$('.dropdowns-menu label').on('click', function(){
    $(this).parents('.dropdowns').removeClass('open');
    var value = $(this).find('input').val();
    $('.dropdowns-menu label').not(this).parents('li').removeClass('active');
    $('.dropdowns-toggle .plc').text(value).addClass('bld');
    var target = $(this).attr('href');
    $('.tab-content .tab-pane').removeClass('active in');
    $(target).addClass('active in');
    console.log($(target));
});
$('.feature-filter .dropdowns-toggle').on('click', function(){
    $(this).parents('.feature-filter').toggleClass('open');
});

// Postage calculator #01 (typing...)
$(document).ready(function() {
    $('input#postcode').val('');
  $('input#postcode').keyup(function(e){  
    var txtInput = $(this).val();
    if (txtInput.length > 2){
      $('#suburb').css('height', 'auto');
      $('#suburb').slideDown();
      $('#suburb').addClass('active');
      $('#suburb ul').html('');
      $('#suburb  .spinner').show();
      e.preventDefault();
      $.ajax({
        url: "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=713&deploy=1&compid=1117015&ns-at=AAEJ7tMQEHiNlvu41bPcPH-Klcl0BC-WPko6HsiOAER-WqJ5IqE&q="+txtInput,
        type: "get",
        crosscallDomain: true,
        dataType: "jsonp"
      })
      .done(function (data) {
        $('#suburb ul').html('');
        if (data.localities == "") {
          $('#suburb .spinner').hide();
          $('#suburb ul').append('<li><strong>Not Found</strong></li>')
        } else {
          displaySuburb(data.localities.locality);
        }
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus + '; ' + errorThrown);
      })
    } else {
      $('#suburb').removeClass('active');
    }
  });
});

function isObject (value) {
  return value && typeof value === 'object' && value.constructor === Object;
}

// Postage calculator #02 (display suburb)
function displaySuburb(data) {
  $('#suburb .spinner').show();
  if (isObject(data)) {
    $('#suburb ul').html('');
    $('#suburb .spinner').hide();
    $('#suburb ul').append('<li><strong>'+data.location+'</strong>, '+data.state+', '+data.postcode+'</li>')
  } else {
    $('#suburb ul').html('');
    $('#suburb .spinner').hide();
    for (var i = 0; i < data.length; i++) {
      $('#suburb ul').append('<li><strong>'+data[i].location+'</strong>, '+data[i].state+', '+data[i].postcode+'</li>')
    }
  }
}

// Postage calculator #03 (get suburb)
$("#suburb ul").on('click','li', function(ev) {
    $('#suburb').slideUp();
    var selectedLoc = $(this).text().split(',');
    $('#postcode').val($(this).text());
    var selectedSuburb = selectedLoc[0].replace(/ /gi, "+");
    var selectedPostcode = selectedLoc[2];

    $('#productId').attr('data-postcode', selectedPostcode);
    $('#productId').attr('data-suburb', selectedSuburb);
}); 

// Postage calculator #04 (click go)
$('#deliverytrigger').click(function(){
  if ($('#postcode').val() != "") {
    var postcode = $('#productId').attr('data-postcode').replace(' ', '');
    var suburb = $('#productId').attr('data-suburb');
    var skuCartPage = $('#allsku').attr('data-sku');
    if (typeof skuCartPage !== 'undefined'){
      var sku = skuCartPage;
    } else {
      var sku = $('.sku').text();
    }
    if ($('#postcode').val().split(',')[0].replace(/ /gi, "+") == suburb) {
      postageCalc(postcode, suburb, sku);
    }
  }
});


// Postage calculator #05 (ajax call...)
function postageCalc(postcode, suburb, sku){
  var url = 'https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=712&deploy=1&compid=1117015&ns-at=AAEJ7tMQmWDVLsk37sTXyeC7k2gKi91BwzdlLcYf8Y9arlMnQew&postcode='+postcode+'&suburb='+suburb+'&item_sku='+sku+'&source=lsg-fitness';
  $.ajax(
    {
      url: url,
      type: "get",
      crosscallDomain: true,
      dataType: "jsonp",
      beforeSend: function(xhr) {
        $('.spinner-1').show();
      }
    }
  ).done(function(data) {
    updatePrice(data.uniq_rates);
  }).fail(function() {
      $('#postage-results').html('Unkown errors, please try again later!');
  })
}

// Postage calculator #06 (display price)
function updatePrice(all_rates){
    if (all_rates === undefined == false ) {
        jQuery(window).trigger('resize').trigger('scroll');
        $('.delivery-pickup .spinner-1').show();
        // Default hidden carrier
        $('.premium_diverse-container').hide();
        
        // Prices
        $('.delivery-check-result').show();
        $('.delivery-check-result .rate').html("N/A");
        $('.delivery-check-result #regular').html("Contact us for a quote");
        // Update cart page
        $('.default-hide.cart-page').hide();

        $('#noprice').hide();
        // Jason files sourced from LSF, don't forget to update the version
        $.getJSON("https://lifespanonline.com.au/postage-query/info/delivery-information.json?123", function (result){
            $( ".delivery-info" ).each(function( index ) {
               var classData = $(this).attr('data-deliveryinfo');
                if (result[classData]) {
                    // Fix different url from other store
                    var whatIncluded = result[classData].includes.join("").replace(/delivery-and-pick-up-information/g, 'shipping-return-policies');
                    $( ".delivery-info."+classData + ' ul').html(whatIncluded);
                    result[classData].additional_info != "" && $( ".delivery-info."+classData + ' ul').append(additionalInfo);
                }
            });

            // Display prices
            for (var i = 0; i < all_rates.length; i++) {
                var idPrices = all_rates[i].type.replace(/\|/g, '_');
                $('.delivery-check-result .'+idPrices+' .cn').html(all_rates[i].display_code);

                //re-display cart delivery option in cart page
                $('.cart-page.'+idPrices).show();
                if (all_rates[i].total_price == 0) {
                    $('.delivery-check-result #'+idPrices).html(result[idPrices].if_zero);
                } else {
                    var ratedelivery = all_rates[i].total_price.toFixed(2);
                    $('.delivery-check-result #'+idPrices).html("$" + ratedelivery);
                }
                // Display carrier which is hidden by default
                if (all_rates[i].type == 'premium|diverse') {
                    $('.premium_diverse-container').show();
                }
                if (all_rates[i].type == 'pickup') {
                    // Get exact location NSW or VIC for pikcup
                    var pickupLoc = all_rates[i].display_code.split('@');
                    $("#pickupLoc").html(pickupLoc[1]);
                    if (all_rates[i].carrier_name == "Pickup NSW" || all_rates[i].carrier_name == "Pickup VIC") {
                        $('.pickup-container').hide();
                    } else {
                        $('.pickup-container').show();
                    }
                }
            }
        });
    } else {
        $('.delivery-check-result').hide();
        $('.check-result-container').append('<p id="noprice" style="font-size:14px;">Please contact us via online chat or phone for a tailored shipping quote. </p>');
    }
    
    $('.delivery-pickup .spinner-1').hide();
    $('.delivery-check-result').slideDown('slow');
}


$('.trigger-delivery-info').click(function(){
  $(this).toggleClass('active');
  var target = $(this).attr('data-target');

  $('.delivery-info.' + target).toggleClass('hide');
  $('.delivery-info:not(.' + target + ')').addClass('hide');
  $('.trigger-delivery-info').not(this).removeClass('active');
});


// WHEN POSTCODE OR SKU is incorrect
function showError(data){
  jQuery(window).trigger('resize').trigger('scroll');
  $('.delivery-pickup .spinner').hide();
  $('.delivery-check-result').slideDown('slow');
  var i;
  for (i = data.length - 1; i >= 0; i--) {
    $('.delivery-check-result').html("<p style='color: #F8ACAC'>"+data[i]+"</p>");
  }
}

// FIX WARRANTY LINK IN PDP
var warrantPositon = $('#pt1 table').length;
if (warrantPositon >= 1) {
    $('#pt1 table:nth-child('+warrantPositon+')').find('a').attr('href', 'https://www.lsgfitness.com.au/pages/warranty');
}
